module.exports = __webpack_public_path__ + "static/media/gallery-leaf-1.36cb2b38.svg";